<div class="spacing--margin-top">
  <agr-extended-notification notificationType="error" [title]="'app.search.error-messages.blocked-title' | translate" data-test="search__order-block">
    <p class="spacing--margin-none-bottom" data-test="search__order-block-description">
      {{ 'app.search.error-messages.' + emptyDescription + '-1' | translate }}
      <a class="text-color--black" [href]="'mailto:' + ('customer-service-mail-address' | translate)"> {{ 'customer-service-mail-address' | translate }} </a>
      {{ 'app.search.error-messages.' + emptyDescription + '-2' | translate }}
    </p>
  </agr-extended-notification>
</div>
